import { AbstractControl, ValidationErrors } from '@angular/forms';

export class OnlySpacesValidator {
    static onlyWhiteSpace(control: AbstractControl): ValidationErrors | null {
        if (control.value && typeof control.value === 'string'  && (control.value as string).trim() === '') {
            return { onlyWhiteSpace: true }
        }
        return null;
    }
}